import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../app/common/reduxs/async/asyncActions';
import {
  portalusersGet,
  portaluserGet,
  portaluserClassyearsGet,
  portaluserEdit,
  portaluserValData,
  portaluserSync,
  portaluserDelete,
  portaluserOrtuDelete,
} from './reduxAction';
import { ASYNC_ACTION_START } from '../../../../app/common/reduxs/async/asyncConstant';
import { checkErr } from '../../../../app/common/helpers/checkRes';
import { fetchFunc } from '../../../../app/common/helpers/fetchHelpers';
import { logsFunc } from '../../../../app/common/helpers/othersHelpers';
import { toastr } from 'react-redux-toastr';
import { SITE_ADDRESS } from '../../../../app/common/data/siteConfig';
import { saveAs } from 'file-saver';

export const getPortalusers = (
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText
) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPortalusers' });
    const formData = new FormData();
    formData.append('itemPerPage', itemPerPage ? itemPerPage : 10);
    formData.append('currentPage', currentPage);
    formData.append('searchText', searchText);
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'portaluser/',
        formData,
        dispatch
      );
      const { items, total } = res;
      const search = {
        currentPage,
        searchText,
        itemPerPage: itemPerPage ? itemPerPage : 10,
      };
      dispatch(portalusersGet({ total, items, search }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getPortalusersExport = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPortalusersExport' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'portaluser/export',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      dispatch(asyncActionFinish());
      return { items, total };
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const groupPortalusers = (
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText
) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'groupPortalusers' });
    const formData = new FormData();
    formData.append('search', 'all');
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'portaluser/group/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      const search = {
        currentPage: 1,
        searchText: '',
        itemPerPage: total ?? 10,
      };
      dispatch(portalusersGet({ total, items, search }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getPortaluser = ({ auth, history, id }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPortaluser' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/detail/' + id,
        formData,
        dispatch
      );
      const portaluser = res.portaluser;
      const portaluserOrtu = res.portaluserOrtu;

      dispatch(portaluserGet({ ...portaluser, portaluserOrtu }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getPortaluserByUserId = ({ auth, history, userId }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPortaluserByUserId' });
    const formData = new FormData();
    formData.append('portaluserId', userId);

    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/detail-byuserid/' + userId,
        formData,
        dispatch
      );
      const portaluser = res.portaluser;
      return portaluser;
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getPortaluserClassyears = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPortaluser' });

    let id = values.id;
    let portaluserId = values.userId;
    const formData = new FormData();
    formData.append('portaluserId', portaluserId);

    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/classyears/' + id,
        formData,
        dispatch
      );
      const classyears = res.classyears;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;

      dispatch(
        portaluserClassyearsGet({
          id,
          classyears,
          jenjangs,
          kelass,
          years,
          sems,
        })
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
// For delete portal user need to check all classyears
export const getPortaluserAllClassyears = ({ auth, history, nis }) => {
  return async (dispatch) => {
    dispatch({
      type: ASYNC_ACTION_START,
      payload: 'getPortaluserAllClassyears',
    });

    const formData = new FormData();

    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/classyears-all/' + nis,
        formData,
        dispatch
      );

      const classyears = res.classyears;
      const absences = res.absences;
      dispatch(asyncActionFinish());
      return { classyears, absences };
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
// Get Data for update others table (classyear, studentAbsence);
export const getEditPortaluserData = ({ auth, history, userId }) => {
  return async (dispatch) => {
    dispatch({
      type: ASYNC_ACTION_START,
      payload: 'getEditPortaluserData',
    });

    const formData = new FormData();

    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/edit-data/' + userId,
        formData,
        dispatch
      );

      const classyears = res.classyears;
      const studentAbsences = res.studentAbsences;

      dispatch(asyncActionFinish());
      return { classyears, studentAbsences };
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editPortaluser = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editPortaluser' });
    let logs = logsFunc('edit', auth.userid, auth.username, values.logs);
    const formData = new FormData();
    formData.append('portaluserId', values.id);
    formData.append('name', values.name);
    formData.append('nis', values.nis);
    formData.append('nisn', values.nisn);
    formData.append('description', values.description);
    if (values?.classyears?.[0]) {
      formData.append('classyears', JSON.stringify(values.classyears));
    }
    if (values?.studentAbsences?.[0]) {
      formData.append(
        'studentAbsences',
        JSON.stringify(values.studentAbsences)
      );
    }
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/edit/' + values.id,
        formData,
        dispatch
      );
      const user = res.user;
      dispatch(portaluserEdit(user));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const statusPortaluser = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'statusPortaluser' });
    const formData = new FormData();
    formData.append('status', values.status);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/status/' + values.id,
        formData,
        dispatch
      );
      const user = res.user;
      dispatch(portaluserEdit(user));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deletePortaluserPesan = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deletePortaluserPesan' });
    const formData = new FormData();
    formData.append('portalUserId', values.userId);
    formData.append('id', values.id);
    formData.append('messageId', values.messageId);
    formData.append('studentMessageId', values.studentMessageId);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/pesan-pribadi/delete/' + values.id,
        formData,
        dispatch
      );
      const portaluser = res.portaluser;
      dispatch(portaluserDelete(portaluser));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getRombelVal = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getRombelVal' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/get-rombel-val/',
        formData,
        dispatch
      );
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      dispatch(portaluserClassyearsGet({ jenjangs, kelass, years, sems }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addPortaluserGetClassyears = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({
      type: ASYNC_ACTION_START,
      payload: 'addPortaluserGetClassyears',
    });
    const formData = new FormData();

    formData.append('jenjangId', values.jenjangId);
    formData.append('kelasId', values.kelasId);
    formData.append('yearId', values.yearId);
    formData.append('semId', values.semId);
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/add-portaluser-get-classyears/',
        formData,
        dispatch
      );
      const classyears = res.classyears;
      dispatch(asyncActionFinish());
      return classyears;
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addPortaluser = ({ auth, history, values, classyears }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'addPortaluser' });
    const formData = new FormData();
    formData.append('portaluser', JSON.stringify(values));
    formData.append('portaluserId', values.userId);
    formData.append('nis', values.nis);
    formData.append('nisn', values.nisn);
    formData.append('name', values.name);
    formData.append('portalUsername', values.username);
    formData.append('defaultPassword', values.defaultPassword);
    formData.append('description', values.description);
    formData.append('creator', values.creator);
    if (classyears) {
      formData.append('classyears', JSON.stringify(classyears));
    }
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'portaluser/add-portaluser/',
        formData,
        dispatch
      );
      const portaluser = res.portaluser;
      dispatch(portaluserGet({ portaluser }));
      history.push(`/portal/portaluser/${portaluser.userId}`);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const importGetValData = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'importGetValData' });
    const formData = new FormData();
    formData.append('values', JSON.stringify(values));
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'portaluser/get-val-data/',
        formData,
        dispatch
      );
      const portaluserExisting = res.portalusers;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      dispatch(
        portaluserValData({ portaluserExisting, jenjangs, kelass, years, sems })
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
export const importPortalUser = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'importPortalUser' });
    let logs = logsFunc('edit', auth.userid, auth.username, values.logs);
    const formData = new FormData();
    formData.append('portalusers', JSON.stringify(values?.importData));
    formData.append('classyears', JSON.stringify(values?.classyears));
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'portaluser/import/',
        formData,
        dispatch
      );
      if (res.status === 'success') {
        toastr.success(
          'Sukses',
          `Data user (${values.importData.length}) berhasil tersimpan`
        );
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const syncPortaluser = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'syncPortaluser' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/sync',
        formData,
        dispatch
      );
      const portusers = res.portalusers;
      const portuserSync = res.portalusersSync;
      dispatch(
        portaluserSync({
          portalusers: portusers,
          portalusersSync: portuserSync,
        })
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const syncSavePortaluser = (auth, history, portalusersMerge) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'syncSavePortaluser' });
    let logs = logsFunc('create', auth.userid, auth.username, null);
    const formData = new FormData();
    formData.append('syncData', JSON.stringify(portalusersMerge));
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'portaluser/sync-save/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      dispatch(
        portalusersGet({
          total,
          items,
          search: {
            currentPage: '',
            searchText: '',
            itemPerPage: '',
          },
        })
      );
      history.push('/portal/portaluser');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const photoUploadPortaluser = ({
  auth,
  history,
  id,
  image,
  filename,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'photoUploadPortaluser' });
    const formData = new FormData();
    formData.append('id', id);
    formData.append('file', image);
    formData.append('filename', filename);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/upload-photo/' + id,
        formData,
        dispatch
      );
      const user = res.user;
      dispatch(portaluserEdit(user));
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const downloadFile = (auth, history, file) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'downloadFile' });
    const formData = new FormData();
    formData.append('userId', auth.userId);
    formData.append('username', auth.username);

    try {
      const fetchData = await fetch(
        SITE_ADDRESS + 'portaluser/download-file/' + file,
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const blob = await fetchData.blob();
      saveAs(blob, file);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const portaluserResetPassword = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'portaluserResetPassword' });
    let logs = logsFunc('edit', auth.userid, auth.username, values.logs);
    const formData = new FormData();
    formData.append('portaluserId', values.id);
    formData.append('newPassword', values.newPassword);
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/reset-password/' + values.id,
        formData,
        dispatch
      );
      dispatch(asyncActionFinish());
      if (res?.status === 'success') {
        const status = res.status;
        const message = res.message;
        const portaluser = res.portaluser;
        dispatch(portaluserEdit(portaluser));
        return { status, message, portaluser };
      }
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const portaluserResetPasswordOrtu = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({
      type: ASYNC_ACTION_START,
      payload: 'portaluserResetPasswordOrtu',
    });
    let logs = logsFunc('edit', auth.userid, auth.username, values.logs);
    const formData = new FormData();
    formData.append('portaluserId', values.id);
    formData.append('newPassword', values.newPassword);
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/reset-password-ortu/' + values.id,
        formData,
        dispatch
      );
      dispatch(asyncActionFinish());
      if (res?.status === 'success') {
        const status = res.status;
        const message = res.message;
        const portaluser = res.portaluser;
        return { status, message, portaluser };
      }
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deletePortaluser = ({ auth, history, values, classyears }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deletePortaluser' });
    const formData = new FormData();
    if (classyears?.[0]) {
      formData.append('classyears', JSON.stringify(classyears));
    }
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'portaluser/delete/' + values.userId,
        formData,
        dispatch
      );
      const portaluser = res.portaluser;
      dispatch(portaluserDelete(portaluser));
      history.push('/portal/portaluser');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deletePortaluserOrtu = ({ auth, history, values, userId }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deletePortaluserOrtu' });
    const formData = new FormData();
    formData.append('userIdOrtu', values.userId);
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'portaluser/delete-ortu/' + userId,
        formData,
        dispatch
      );
      const portaluserId = res.userId;
      const portaluserOrtu = res.portaluserOrtu;
      dispatch(
        portaluserOrtuDelete({
          userId: portaluserId,
          portaluserOrtu: portaluserOrtu,
        })
      );
      history.push(`/portal/portaluser/${userId}/akun-ortu`);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteAllPortalusers = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteAllPortalusers' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'portaluser/delete-all/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      const search = {
        currentPage: 1,
        searchText: '',
        itemPerPage: 10,
      };
      dispatch(portalusersGet({ total, items, search }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
